export const FF_6271_EMAIL_OVERAGE_FEE = 'rocinante.plat.6271.email.overage.fee';
export const FF_CHARGEBEE_ENABLE_EDIT_PORTAL_BUTTON = 'plat.5313.enable.chargebee.edit.button';
export const FF_SHOW_MESSAGE_BUNDLES = 'rocinante.plat.7264.message.bundles';
export const FF_PLAT_4497_IN_APP_CANCEL_REQUEST = 'rocinante.plat.4497.in.app.cancel.request';
export const FF_PLAT_9320_INTEGRATIONS_AUTH_FLOW_V2 = 'keap.integrations.account.central.auth.flow';
export const FF_AUTH_9113_DISABLE_USERNAME_GOOGLE_UPDATE = 'auth.9113.disable.username.google.update';
export const FF_INVITE_SIGNUP_FORM_ON_AC_WEB = 'invite.signup.form.on.ac.web';
